import { css } from 'design'
import { Stack } from 'primitives/containers'
import React from 'react'
import { useSelector } from 'react-redux'

import { LiveChatPreview } from '../../components/live_chat_widget/live_chat_preview'
import { WidgetHeaderBar } from '../../components/live_chat_widget/widget_header_bar'
import { getLiveChatTopics } from '../../reduxes/slices/topics/selectors'
import { WidgetPageContainer } from './widget_page_container'

export const PastConversationsPage = () => {
  const topics: any = useSelector(getLiveChatTopics)

  return (
    <WidgetPageContainer videoVariant={false}>
      <WidgetHeaderBar bgVariant />
      <div className={containerStyles()}>
        <Stack as={'ul'} gap={4} css={{ margin: '$4', maxWidth: 400 }}>
          {topics.map((topic: any) => {
            return (
              <li key={topic.id}>
                <LiveChatPreview topic={topic} />
              </li>
            )
          })}
        </Stack>
      </div>
    </WidgetPageContainer>
  )
}

const containerStyles = css({
  flexGrow: 1,
  overflowY: 'scroll',
})
